import { generatePath } from '@framework/ui/core/router/TypedRoute.tsx';

/**
 * Genera il path per la visualizzazione della richiesta.
 * Tiene conto se il tema richiede di fare redirect al modulo principale.
 */
export function getSubmissionPath(
  redirectToFirstModule: boolean,
  id: string | null | undefined,
) {
  const safeId = id ?? '<unknown>';
  return redirectToFirstModule
    ? generatePath('/richieste/:id/modulo-principale', { id: safeId })
    : generatePath('/richieste/:id', { id: safeId });
}
